import { useRef, useCallback } from 'react';
import { Modal } from 'antd';
import canvasWebSocket from '@/services/websocket-service';

/**
 * Shared hook for showing the "WebSocket connection failed" modal with a ref
 * guard so the modal is not shown multiple times. Use in conversation-panel and
 * guided-v2 (or any component that checks canvasWebSocket connection status).
 */
export function useWsConnectionGuard() {
  const wsConnectionModalOpenRef = useRef(false);

  const showWsConnectionFailedModal = useCallback(() => {
    if (wsConnectionModalOpenRef.current) return;
    wsConnectionModalOpenRef.current = true;
    const connectionFailure = canvasWebSocket.getLastConnectionFailure();
    const isHandshakeFailure = connectionFailure?.phase === 'handshake';

    Modal.error({
      title: isHandshakeFailure ? 'Network Connection Blocked' : 'Service Connection Failed',
      content: isHandshakeFailure
        ? "Your network may be blocking this feature. If you're on a VPN or corporate network, try disabling it temporarily or contact your IT team."
        : 'We could not connect to the service. Please refresh the page and try again.',
      okText: 'OK',
      onOk: () => {
        wsConnectionModalOpenRef.current = false;
      },
      onCancel: () => {
        wsConnectionModalOpenRef.current = false;
      },
      afterClose: () => {
        wsConnectionModalOpenRef.current = false;
      },
    });
  }, []);

  return showWsConnectionFailedModal;
}
